module.exports = __webpack_public_path__ + "static/media/logo_droid_navbar.eb0def7f.png";